import {NavigationPathKey, TranslationKey} from '@enums'
import {SearchTableWrapper} from '@wrappers'

import React from 'react'

import {UIKit} from '@components'

import {useDealerSearchModel} from './dealer-search-model'

/**
 * Dealer Search page
 */
export function DealerSearchPage() {
  const {navigate, visibilityModel, t, showCreateButton, rows, columns} = useDealerSearchModel()

  return (
    <SearchTableWrapper>
      <UIKit.Table
        {...(showCreateButton && {
          buttonProps: {
            buttonText: t(TranslationKey['Add new dealer']),
            onClick: () => navigate(NavigationPathKey.DEALER_CREATION),
          },
        })}
        columns={columns}
        rows={rows}
        title={t(TranslationKey['List of dealers'])}
        visibilityModel={visibilityModel}
      />
    </SearchTableWrapper>
  )
}
